import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import Avatar from 'material-ui/Avatar';
import {ListItem} from 'material-ui/List';
import style from '../../../styles/styles';
import Terrain from 'material-ui/svg-icons/maps/terrain';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import muiThemeable from 'material-ui/styles/muiThemeable';
import MediasService from "../../../services/medias";
import {transparent} from "material-ui/styles/colors";
import {TRAIL_PAGE} from "../../../constants/routes";
import { Chip } from 'material-ui';
import styles from '../../page/PageItem.css';
import ActionVisibleOff from 'material-ui/svg-icons/action/visibility-off';

class Trail extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        trail: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        handleRemoveTrail: PropTypes.func,
    };

    // Handlers

    handleRemoveTrail = () => {
        this.props.handleRemoveTrail(this.props.trail);
    };

    // Render
    // Unknown event handler property `onKeyboardFocus`. It will be ignored.
    // delete this ?
    renderRightIconButton() {
        if (this.props.trail.is_favorite) {
            return <Avatar
                backgroundColor={transparent}
                color={this.props.muiTheme.palette.primary2Color}
                icon={
                    <ActionFavorite
                        color={this.props.muiTheme.palette.primary2Color}
                    />
                }
            />;
        }

    }

    renderFirstMedia() {
        const trail = this.props.trail;

        if (trail.medias) {
            let images = MediasService.sortedMediasForShortMime(trail.medias, MediasService.IMAGES);

            if (images.length > 0) {
                return <Avatar src={images[0].link} style={style.image.cover}/>;
            }
        }

        return <Avatar icon={<Terrain/>}/>;
    }

    render() {
        const {trail} = this.props;

        return (
            <Link to={TRAIL_PAGE.replace(':appId', this.props.app.id).replace(':trailId', this.props.trail.id)}>
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderFirstMedia()}
                    rightIcon={!trail.visible && <ActionVisibleOff />}
                    primaryText={
                        <div>
                            {trail.name || 'No name'}
                            {trail.tag &&
                            <Chip style={{...styles.chip, ...style.chip}}>
                                {trail.tag}
                            </Chip>
                            }
                        </div>
                    }
                    secondaryText={
                        <div>
                            {trail.gpx && 'gpx'}
                            {trail.geojson && 'geojson'}
                            {trail.kml && 'kml'}
                            {!trail.gpx && !trail.kml && !trail.geojson && 'No trail data'}
                        </div>
                    }
                    rightIconButton={this.renderRightIconButton()}
                    disableKeyboardFocus={true}
                />
            </Link>
        );
    }
}

export default muiThemeable()(Trail);



// WEBPACK FOOTER //
// src/components/openexplore/Trail/Trail.js